import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import ProtectedRoute from './../components/auth/protected-route.jsx';
import PermissionRoute from './../components/auth/permission-route.jsx';
import KycStepPage from './../pages/system/kyc-step.jsx';
import KycFieldDependenciesPage from './../pages/system/kyc-field-dependencies.jsx';
import Login from './../pages/login/login.jsx';
import ForgotPasswordPage from './../pages/forgot-password/forgot-password.jsx';
import ResetPasswordPage from './../pages/reset-password/reset-password.jsx';
import SupportAccessLoginPage from './../pages/support-access/support-access-login.jsx';
import SecurityPage from './../pages/security/security-page.jsx';
import AppShell from './../app/app-shell.jsx';
import CallsPage from './../modules/calls/ui/calls-page.jsx';
import TelephonyPage from './../modules/calls/ui/telephony-page.jsx';
import HelpReaderPage from './../help/ui/help-reader-page.jsx';
import WikiPage from './../wiki/ui/wiki-page.jsx';
import DashboardPageContainer from './../modules/dashboard/ui/dashboard-page-container.jsx';
import ProfilesPageContainer from './../modules/profiles/ui/profiles-page-container.jsx';
import ProfileDetailsPageContainer from './../modules/profiles/ui/profile-details-page-container.jsx';
import LeadsPageContainer from './../modules/leads/ui/leads-page-container.jsx';
import LeadImportPage from './../modules/leads/ui/lead-import-page.jsx';
import LeadCreatePageContainer from './../modules/leads/ui/lead-create-page-container.jsx';
import DocumentsPageContainer from './../modules/documents/ui/documents-page-container.jsx';
import AccountsPageContainer from './../modules/accounts/ui/accounts-page-container.jsx';
import AccountDetailsPageContainer from './../modules/accounts/ui/account-details-page-container.jsx';
import TransactionsPageContainer from './../modules/transactions/ui/transactions-page-container.jsx';
import TransactionDetailsPageContainer from './../modules/transactions/ui/transaction-details-page-container.jsx';
import SystemUsersPageContainer from './../modules/system-users/ui/system-users-page-container.jsx';
import SystemUserDetailsPageContainer from './../modules/system-users/ui/system-user-details-page-container.jsx';
import SystemAclPageContainer from './../modules/system-acl/ui/system-acl-page-container.jsx';
import SystemAclRolePageContainer from './../modules/system-acl/ui/system-acl-role-page-container.jsx';
import SystemEventsPageContainer from './../modules/system-events/ui/system-events-page-container.jsx';
import SecurityAlertsPageContainer from './../modules/security-alerts/ui/security-alerts-page-container.jsx';
import SecurityPolicyPageContainer from './../modules/security-policy/ui/security-policy-page-container.jsx';
import ActionLogExplorerPageContainer from './../modules/action-log-explorer/ui/action-log-explorer-page-container.jsx';
import SystemAgreementsPageContainer from './../modules/system-agreements/ui/system-agreements-page-container.jsx';
import PaymentSettingsPage from './../modules/payment-settings/ui/payment-settings-page.jsx';
import CurrencyRatesPageContainer from './../modules/currency-rates/ui/currency-rates-page-container.jsx';
import SystemEmailSettingsPageContainer from './../modules/system-email-settings/ui/system-email-settings-page-container.jsx';
import SystemGeneralSettingsPageContainer from './../modules/system-general-settings/ui/system-general-settings-page-container.jsx';
import SystemTransactionSettingsPageContainer from './../modules/system-transaction-settings/ui/system-transaction-settings-page-container.jsx';
import VerificationSettingsPage from './../modules/verification-settings/ui/verification-settings-page.jsx';
import SystemJurisdictionsPageContainer from './../modules/system-jurisdictions/ui/system-jurisdictions-page-container.jsx';
import SystemTradingPlatformsPageContainer from './../modules/system-trading-platforms/ui/system-trading-platforms-page-container.jsx';
import SystemTradingServersPageContainer from './../modules/system-trading-servers/ui/system-trading-servers-page-container.jsx';
import SystemTradingAccountsPageContainer from './../modules/system-trading-accounts/ui/system-trading-accounts-page-container.jsx';
import SystemTasksPageContainer from './../modules/system-tasks/ui/system-tasks-page-container.jsx';
import SystemKycPageContainer from './../modules/system-kyc/ui/system-kyc-page-container.jsx';
import SystemEmailTemplatesListPageContainer from './../modules/system-email-templates/ui/system-email-templates-list-page-container.jsx';
import SystemEmailTemplatesWrapPageContainer from './../modules/system-email-templates/ui/system-email-templates-wrap-page-container.jsx';
import SystemSaveRestorePageContainer from './../modules/system-save-restore/ui/system-save-restore-page-container.jsx';
import SystemLegalPageContainer from './../modules/system-legal/ui/system-legal-page-container.jsx';
import TenantBackupsPageContainer from './../modules/tenant-backups/ui/tenant-backups-page-container.jsx';
import ComplianceSarPageContainer from './../modules/compliance-sar/ui/compliance-sar-page-container.jsx';
import ComplianceComplaintsPageContainer from './../modules/compliance-complaints/ui/compliance-complaints-page-container.jsx';
import ComplianceBreachPageContainer from './../modules/compliance-breach/ui/compliance-breach-page-container.jsx';
import SystemUserSettingsLayout from './../modules/system-navigation/ui/system-user-settings-layout.jsx';
import SystemSettingsLayout from './../modules/system-navigation/ui/system-settings-layout.jsx';
import SystemSecurityLayout, { SystemSecurityIndexRedirect } from './../modules/system-navigation/ui/system-security-layout.jsx';
import FinancialRegulationRoute from './../modules/system-navigation/ui/financial-regulation-route.jsx';
import InternalMailPageContainer from './../modules/internal-mail/ui/internal-mail-page-container.jsx';
import SupportTicketsPageContainer from './../modules/support/ui/support-tickets-page-container.jsx';
import SupportTicketDetailsContainer from './../modules/support/ui/support-ticket-details-container.jsx';
import PartnerSettingsPageContainer from './../modules/partner-settings/ui/partner-settings-page-container.jsx';
import PartnersPageContainer from './../modules/partners/ui/partners-page-container.jsx';
import PartnerDetailsPageContainer from './../modules/partners/ui/partner-details-page-container.jsx';
import CommissionsPageContainer from './../modules/commissions/ui/commissions-page-container.jsx';
import CommissionPlansPageContainer from './../modules/commission-plans/ui/commission-plans-page-container.jsx';
import CommissionPlanDetailsPageContainer from './../modules/commission-plans/ui/commission-plan-details-page-container.jsx';
import MarketingEmailsLayout from './../modules/marketing-emails/ui/marketing-emails-layout.jsx';
import MarketingEmailCampaignsPageContainer from './../modules/marketing-emails/ui/marketing-email-campaigns-page-container.jsx';
import MarketingEmailCampaignEditorPageContainer from './../modules/marketing-emails/ui/marketing-email-campaign-editor-page-container.jsx';
import MarketingEmailProvidersPageContainer from './../modules/marketing-emails/ui/marketing-email-providers-page-container.jsx';
import MarketingEmailSettingsPageContainer from './../modules/marketing-emails/ui/marketing-email-settings-page-container.jsx';
import MigrationPlaceholderPage from './../shared/ui/migration-placeholder/migration-placeholder-page.jsx';

const SYSTEM_SECURITY_PERMISSIONS = ['system.events.view', 'security_alert.view', 'audit_log.view', 'system.manage'];

function LegacySystemAclRedirect() {
  const { roleId } = useParams();
  const normalizedRoleId = String(roleId || '').trim();
  const target = normalizedRoleId
    ? `/system/security/access-control/${encodeURIComponent(normalizedRoleId)}`
    : '/system/security/access-control';

  return <Navigate to={target} replace />;
}

const AppRoute = [
  {
    path: 'login',
    element: <Login />,
  },
  {
    path: 'forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: 'reset-password/:otp',
    element: <ResetPasswordPage />,
  },
  {
    path: 'support-access',
    element: <SupportAccessLoginPage />,
  },
  {
    path: 'help-view/:slug',
    element: (
      <ProtectedRoute>
        <HelpReaderPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <AppShell />,
    children: [
      { path: 'calls', element: <ProtectedRoute><PermissionRoute requiredPermission="calls.view"><CallsPage /></PermissionRoute></ProtectedRoute> },
      { path: 'system/telephony', element: <ProtectedRoute><PermissionRoute requiredPermission="calls.settings"><TelephonyPage /></PermissionRoute></ProtectedRoute> },
      { path: '', element: <Navigate to="/dashboard" replace /> },
      {
        path: 'dashboard',
        element: (
          <ProtectedRoute>
            <DashboardPageContainer />
          </ProtectedRoute>
        ),
      },
      {
        path: 'wiki',
        element: (
          <ProtectedRoute>
            <WikiPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'wiki/:slug',
        element: (
          <ProtectedRoute>
            <WikiPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'security',
        element: (
          <ProtectedRoute>
            <SecurityPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'profiles',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="profile.view">
              <ProfilesPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'leads/import',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="lead.view">
              <PermissionRoute requiredPermission="lead.create"><LeadImportPage /></PermissionRoute>
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'leads/new',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="lead.view">
              <LeadCreatePageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'leads',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="lead.view">
              <LeadsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'profiles/:id',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="profile.view">
              <ProfileDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'documents',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="document.view">
              <DocumentsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'accounts',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="account.view">
              <AccountsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'accounts/:id',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="account.view">
              <AccountDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'transactions',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="transaction.view">
              <TransactionsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'transactions/:id',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="transaction.view">
              <TransactionDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'marketing/emails',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredAnyPermission={['marketing_email.view', 'marketing_email.provider_manage']}>
              <MarketingEmailsLayout />
            </PermissionRoute>
          </ProtectedRoute>
        ),
        children: [
          { path: '', element: <Navigate to="/marketing/emails/campaigns" replace /> },
          {
            path: 'campaigns',
            element: (
              <PermissionRoute requiredPermission="marketing_email.view">
                <MarketingEmailCampaignsPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'campaigns/new',
            element: (
              <PermissionRoute requiredPermission="marketing_email.view">
                <MarketingEmailCampaignEditorPageContainer mode="create" />
              </PermissionRoute>
            ),
          },
          {
            path: 'campaigns/:uid',
            element: (
              <PermissionRoute requiredPermission="marketing_email.view">
                <MarketingEmailCampaignEditorPageContainer mode="edit" />
              </PermissionRoute>
            ),
          },
          {
            path: 'providers',
            element: (
              <PermissionRoute requiredPermission="marketing_email.view">
                <MarketingEmailProvidersPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'settings',
            element: (
              <PermissionRoute requiredPermission="marketing_email.provider_manage">
                <MarketingEmailSettingsPageContainer />
              </PermissionRoute>
            ),
          },
        ],
      },
      {
        path: 'system/users',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="user.view">
              <SystemUsersPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/users/:id',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="user.view">
              <SystemUserDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/acl',
        element: <Navigate to="/system/security/access-control" replace />,
      },
      {
        path: 'system/acl/new',
        element: <Navigate to="/system/security/access-control/new" replace />,
      },
      {
        path: 'system/acl/:roleId',
        element: <LegacySystemAclRedirect />,
      },
      {
        path: 'system/events',
        element: <Navigate to="/system/security/events" replace />,
      },
      {
        path: 'system/security',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredAnyPermission={SYSTEM_SECURITY_PERMISSIONS}>
              <SystemSecurityLayout />
            </PermissionRoute>
          </ProtectedRoute>
        ),
        children: [
          { path: '', element: <SystemSecurityIndexRedirect /> },
          {
            path: 'events',
            element: (
              <PermissionRoute requiredPermission="system.events.view">
                <SystemEventsPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'alerts',
            element: (
              <PermissionRoute requiredPermission="security_alert.view">
                <SecurityAlertsPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'policy',
            element: (
              <PermissionRoute requiredPermission="security_alert.view">
                <SecurityPolicyPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'action-log',
            element: (
              <PermissionRoute requiredPermission="audit_log.view">
                <ActionLogExplorerPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'access-control',
            element: (
              <PermissionRoute requiredPermission="system.manage">
                <SystemAclPageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'access-control/new',
            element: (
              <PermissionRoute requiredPermission="system.manage">
                <SystemAclRolePageContainer />
              </PermissionRoute>
            ),
          },
          {
            path: 'access-control/:roleId',
            element: (
              <PermissionRoute requiredPermission="system.manage">
                <SystemAclRolePageContainer />
              </PermissionRoute>
            ),
          },
        ],
      },
      {
        path: 'system/legal',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredAnyPermission={['document.view', 'settings.manage']}>
              <SystemLegalPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/metrics',
        element: <Navigate to="/system/security/events" replace />,
      },
      {
        path: 'system/metrics/:tab',
        element: <Navigate to="/system/security/events" replace />,
      },
      {
        path: 'payment-settings/providers',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <PaymentSettingsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'payment-settings/providers/:providerId',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <PaymentSettingsPage />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'payment-settings/bank-transfer',
        element: <Navigate to="/payment-settings/providers/OfflineBankTransfer" replace />,
      },
      {
        path: 'payment-settings/crypto-transfer',
        element: <Navigate to="/payment-settings/providers/OfflineCryptoTransfer" replace />,
      },
      {
        path: 'payment-settings/currency-rates',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <CurrencyRatesPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/user-settings',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <SystemUserSettingsLayout />
            </PermissionRoute>
          </ProtectedRoute>
        ),
        children: [
          { path: '', element: <Navigate to="/system/user-settings/agreements" replace /> },
          { path: 'agreements', element: <SystemAgreementsPageContainer /> },
          { path: 'jurisdictions', element: <SystemJurisdictionsPageContainer /> },
          { path: 'trading-platforms', element: <SystemTradingPlatformsPageContainer /> },
          { path: 'trading-servers', element: <SystemTradingServersPageContainer /> },
          { path: 'trading-accounts', element: <SystemTradingAccountsPageContainer /> },
          { path: 'kyc', element: <SystemKycPageContainer /> },
          { path: 'kyc/new', element: <KycStepPage mode="create" basePath="/system/user-settings/kyc" /> },
          { path: 'kyc/:id/view', element: <KycStepPage mode="view" basePath="/system/user-settings/kyc" /> },
          { path: 'kyc/:id/edit', element: <KycStepPage mode="edit" basePath="/system/user-settings/kyc" /> },
          { path: 'kyc/:id/edit/field/:fieldId/dependencies', element: <KycFieldDependenciesPage basePath="/system/user-settings/kyc" /> },
          { path: 'backup-restore', element: <SystemSaveRestorePageContainer /> },
          { path: 'email-templates', element: <Navigate to="/system/user-settings/email-templates/list" replace /> },
          { path: 'email-templates/list', element: <SystemEmailTemplatesListPageContainer /> },
          { path: 'email-templates/header-footer', element: <SystemEmailTemplatesWrapPageContainer /> },
        ],
      },
      {
        path: 'system/settings',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <SystemSettingsLayout />
            </PermissionRoute>
          </ProtectedRoute>
        ),
        children: [
          { path: '', element: <Navigate to="/system/settings/general" replace /> },
          { path: 'general', element: <SystemGeneralSettingsPageContainer /> },
          { path: 'branding', element: <SystemGeneralSettingsPageContainer mode="branding" /> },
          { path: 'tasks', element: <SystemTasksPageContainer /> },
          { path: 'email', element: <SystemEmailSettingsPageContainer /> },
          { path: 'transaction-settings', element: <SystemTransactionSettingsPageContainer /> },
          { path: 'verification', element: <VerificationSettingsPage /> },
        ],
      },
      {
        path: 'system/save-restore',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="backup.view">
              <TenantBackupsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/compliance',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="compliance.view">
              <FinancialRegulationRoute>
                <Navigate to="/system/compliance/sar" replace />
              </FinancialRegulationRoute>
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/compliance/sar',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="compliance.view">
              <FinancialRegulationRoute>
                <ComplianceSarPageContainer />
              </FinancialRegulationRoute>
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/compliance/complaints',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="compliance.view">
              <FinancialRegulationRoute>
                <ComplianceComplaintsPageContainer />
              </FinancialRegulationRoute>
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'system/compliance/breach',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="compliance.view">
              <FinancialRegulationRoute>
                <ComplianceBreachPageContainer />
              </FinancialRegulationRoute>
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'internal-mail',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="message.view">
              <InternalMailPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'partners',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="partner.view">
              <PartnersPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'partners/settings',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="settings.view">
              <PartnerSettingsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'partners/:uid',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="partner.view">
              <PartnerDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'commissions',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="commission.view">
              <CommissionsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'commission-plans',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="commission.view">
              <CommissionPlansPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'commission-plans/:uid',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="commission.view">
              <CommissionPlanDetailsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'support',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="ticket.view">
              <SupportTicketsPageContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: 'support/:uid',
        element: (
          <ProtectedRoute>
            <PermissionRoute requiredPermission="ticket.view">
              <SupportTicketDetailsContainer />
            </PermissionRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '*',
        element: (
          <ProtectedRoute>
            <MigrationPlaceholderPage />
          </ProtectedRoute>
        ),
      },
    ],
  },
];


export default AppRoute;
